( function () {
    'use strict';
    /**
     * Extranet
     * @namespace
     */
    master.extranet = {
        /** @function */
        /**
         * Validate and submit login-form and handle the responds, so we can send the user to the correct page
         * @async
         */
        loginModal: function () {
            var jForm = jQuery( 'form[name="ExtUserForm"]' ),
                jWorkshopGroupID = jQuery( '#master-root' ).data( 'workshop-group-id' ),
                jError = '<div class="alert alert-error"><button type="button" class="close" data-dismiss="alert">&times;</button><p>' + jForm.data( 'error' ) + '</p></div>';
            if ( jQuery( '.js-login-attempt' ).length ) {
                location.href = '/';
            }
            jForm.find( 'button[type="submit"]' ).on( 'click', function ( event ) {
                var isCheckout = jQuery( '.e-checkout-form' ).length,
                    DW_Extranet = jQuery.cookie( 'DW_Extranet' );
                event.preventDefault();
                if ( DW_Extranet && DW_Extranet.split( '&' )[ 0 ].split( '=' )[ 1 ] !== '' ) {
                    jForm.submit();
                }
                else {
                    if ( jForm.valid() ) {
                        jQuery.ajax( {
                            url: location.href,
                            type: 'POST',
                            beforeSend: function () {
                                jQuery( '.js-e-login-modal-load-content' ).find( '.js-master-login-modal-screen-spinner' ).slideDown( master.settings.animateSpeed );
                            },
                            data: jForm.serialize(),
                        } ).done( function ( data ) {
                            var jHtml = jQuery.parseHTML( data ),
                                fetchedData = 0,
                                extranetGroup = 0,
                                userWorkshopID = '';
                            for ( var i = 0; i < jHtml.length; i++ ) {
                                if ( jHtml[ i ].id === 'js-e-login-modal-screen' ) {
                                    fetchedData = 1;
                                }
                                if ( jHtml[ i ].id === 'isExtranet' ) {
                                    extranetGroup = jHtml[ i ].content;
                                }
                                if ( jHtml[ i ].id === 'userWorkshopID' ) {
                                    userWorkshopID = jHtml[ i ].content;
                                }
                            }
                            if ( fetchedData === 0 ) {
                                if ( userWorkshopID !== '' ) {
                                    if ( !jQuery( 'meta[id="workshopID"]' ).length ) {
                                        jQuery.post( master.data.workshops.endpoint, {
                                            action: master.data.workshops.actions.set,
                                            workshop: userWorkshopID
                                        } );
                                    }
                                    else {
                                        if ( jQuery( 'meta[id="workshopID"]' ).attr( 'content' ) === '' ) {
                                            jQuery.post( master.data.workshops.endpoint, {
                                                action: master.data.workshops.actions.set,
                                                workshop: userWorkshopID
                                            } );
                                        }
                                    }
                                }
                                var extranetGroups = extranetGroup.split( ',' );
                                if ( isCheckout === 0 ) {
                                    if ( jQuery.inArray( jWorkshopGroupID, extranetGroups ) !== -1 ) {
                                        location.href = jForm.data( 'redirect' );
                                    }
                                    else {
                                        location.href = location.href;
                                    }
                                }
                                else {
                                    location.href = location.href;
                                }
                            }
                            else {
                                jQuery( '.js-e-login-modal-load-content' ).find( '.js-master-login-modal-screen-spinner' ).fadeOut( master.settings.animateSpeed, function () {
                                    if ( jQuery( '.js-e-login-modal' ).find( '.alert-error' ).length === 0 ) {
                                        jForm.before( jError );
                                    }
                                } );
                            }
                        } );
                    }
                }
            } );
            jForm.find( 'input' ).on( 'focus', function () {
                var errorBox = jQuery( '.js-e-login-modal' ).find( '.alert-error' );
                if ( errorBox.length > 0 ) {
                    errorBox.slideUp( master.settings.animateSpeed, function () {
                        jForm.find( 'input' ).val( '' );
                        jQuery( this ).remove();
                    } );
                }
            } );
        },
        /** @function */
        /**
         * Log user out and clear service orderlines
         */
        logout: function () {
            jQuery( '.js-logout-user' ).on( 'click', function ( event ) {
                event.preventDefault();
                master.checkout.cart.commands.removeServicelines( master.extranet.logoutCallback );
            } );
        },
        /** @function */
        /**
         * Set redirect
         */
        logoutCallback: function () {
            location.href = jQuery( '.js-logout-user' ).attr( 'href' );
        },
        /** @namespace */
        account: {
            /** @function */
            /**
             * Set username
             */
            create: function () {
                jQuery( '.js-master-account-new-basic-information' ).find( 'input[name="UserManagement_Form_Email"]' ).on( 'change', function () {
                    jQuery( '.js-master-account-new-basic-information' ).find( 'input[name="UserManagement_Form_UserName"]' ).val( jQuery( this ).val() );
                } );
            },
            /** @function */
            /**
             * Animations for deleting user
             */
            delete: function () {
                jQuery( '.js-account-delete-my-user' ).on( 'click', function () {
                    jQuery( '.js-delete-account-confirmation' ).fadeIn( master.settings.animateSpeed, function () {
                        jQuery( '.js-account-delete-my-user' ).addClass( 'open' );
                        jQuery( this ).find( '.js-delete-account-confirmation-inner' ).addClass( 'open' );
                    } );
                } );
                jQuery( '.js-account-delete-my-user-cancel' ).on( 'click', function () {
                    jQuery( '.js-delete-account-confirmation' ).fadeOut( master.settings.animateSpeed, function () {
                        jQuery( '.js-account-delete-my-user' ).removeClass( 'open' );
                        jQuery( this ).find( '.js-delete-account-confirmation-inner' ).removeClass( 'open' );
                    } );
                } );
            },
            /** @function */
            /**
             * Animations + function to delete orders from overview
             */
            deleteOrder: function () {
                jQuery( '.js-delete-booking' ).on( 'click', function ( event ) {
                    event.preventDefault();
                    jQuery( this ).closest( 'td' ).find( '.js-delete-booking-confirmation' ).addClass( 'open' );
                } );
                jQuery( '.js-delete-booking-confirmation-cancel' ).on( 'click', function ( event ) {
                    event.preventDefault();
                    jQuery( this ).closest( 'td' ).find( '.js-delete-booking-confirmation' ).removeClass( 'open' );
                } );
                jQuery( '.js-delete-booking-confirmation-confirm' ).on( 'click', function ( event ) {
                    event.preventDefault();
                    var jClosestRow = jQuery( this ).closest( 'td' ),
                        confirmUrl = jQuery( this ).data( 'delete' );
                    jQuery.post( confirmUrl, function () {
                        jClosestRow.find( '.js-delete-booking' ).css( 'visibility', 'hidden' ).after( '<span class="master-account-details-orderlist-cancel-booking-confirm-animation"><i class="material-icons">done</i> Aflyst</span>' );
                        jClosestRow.find( '.js-delete-booking-confirmation' ).removeClass( 'open' );
                        setTimeout( function () {
                            jClosestRow.find( '.master-account-details-orderlist-cancel-booking-confirm-animation' ).addClass( 'confirmed' );
                            setTimeout( function () {
                                jClosestRow.find( '.master-account-details-orderlist-cancel-booking-confirm-animation' ).remove();
                            }, 2000 );
                        }, 300 );
                    } );
                } );
            },
            init: function () {
                this.create();
                this.delete();
                this.deleteOrder();
            }
        },
        /**
     * @namespace
     */
        myInfo: {
            /** @function */
            /**
             * Update userinfo
             */
            liveUpdate: function ( infoItem, updatedValue ) {
                jQuery( '.js-user-info-' + infoItem ).text( updatedValue ).parent().show();
            },
            /** @function */
            /**
             * Update user car info
             */
            setCarInfo: function () {
                var myCarInfo = JSON.parse( master.store.session.myCar );
                if ( myCarInfo !== null ) {
                    var myCarInfoString = '<ul class="unstyled"><li><i class="material-icons">directions_car</i> ' + myCarInfo.Fabrikattekst + ' ' + myCarInfo.Modeltekst + '</li><li>Registreringsnummer: ' + myCarInfo.Registreringsnummer + '</li></ul>';
                    master.utils.templating( '.js-master-user-info-and-search-mobile-carinfo', 'myCarInfo', myCarInfoString );
                    master.utils.templating( '.js-master-user-info-and-search-actionlist-carInfo', 'myCarInfo', myCarInfo.Registreringsnummer, 'show' );
                }
                else {
                    master.utils.templating( '.js-master-user-info-and-search-mobile-carinfo', 'myCarInfo', null );
                }
            },
            init: function () {
                this.setCarInfo();
            }
        },
        init: function () {
            master.extranet.loginModal();
            master.extranet.logout();
            master.extranet.account.init();
            master.extranet.myInfo.init();
        }
    };
}() );
